const AUTHENTICATION_CONSTANTS = {
    AUTH_BASE_URL: process.env.REACT_APP_AUTH_URL,
    AUTH_ENDPOINT: "account/signin",
    GRANT_TYPE: {
        PASSWORD: "password",
        REFRESH: "refresh_token",
        PASSWORD_RESET_CODE: "password_reset_code",
        PASSWORD_RESET: "password_reset",
    },
    CLIENT_ID: "718e00ce-1421-4f06-8020-d50f92eb4632",
};

export default AUTHENTICATION_CONSTANTS;